import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { C, Icon, MODULES, StatusChip, formatDate, inputStyle } from "./tickets";

const moduleLabel = (value) => MODULES.find((m) => m.value === value)?.label || value;

export default function TicketList({ canReview, onOpen }) {
  const [scope, setScope] = useState("mine");
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    const timer = setTimeout(() => {
      api
        .get("/tickets", { params: { scope: scope === "all" ? "" : scope, search, limit: 50 } })
        .then(({ data }) => active && setRows(data.rows))
        .catch(() => active && setRows([]))
        .finally(() => active && setLoading(false));
    }, search ? 400 : 0);
    return () => { active = false; clearTimeout(timer); };
  }, [scope, search]);

  const tabs = [
    { value: "mine", icon: "User", title: "My tickets" },
    ...(canReview ? [{ value: "awaiting", icon: "Hourglass", title: "Waiting for my vote" }, { value: "all", icon: "List", title: "All tickets" }] : []),
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, background: C.secondary }}>
      <div style={{ display: "flex", gap: 6, padding: "10px 12px 0" }}>
        {tabs.length > 1 && tabs.map((tab) => (
          <button key={tab.value} type="button" title={tab.title} onClick={() => setScope(tab.value)} style={{ width: 32, height: 32, borderRadius: 8, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", border: `1px solid ${scope === tab.value ? C.primary : C.secondaryDark}`, background: scope === tab.value ? C.primary : C.white }}>
            <Icon name={tab.icon} size={15} color={scope === tab.value ? C.white : C.primary} />
          </button>
        ))}
        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" style={{ ...inputStyle, flex: 1 }} />
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: 12, display: "flex", flexDirection: "column", gap: 8 }}>
        {!loading && !rows.length && (
          <div style={{ margin: "auto", color: C.secondaryDark }}><Icon name="Inbox" size={32} /></div>
        )}
        {rows.map((ticket) => (
          <button key={ticket.id} type="button" onClick={() => onOpen(ticket.id)} style={{ textAlign: "left", cursor: "pointer", background: C.white, border: `1px solid ${C.secondaryDark}`, borderRadius: 10, padding: "8px 10px", display: "flex", flexDirection: "column", gap: 4 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Icon name={ticket.type === "bug" ? "Bug" : "Lightbulb"} size={13} color={C.orange} />
              <span style={{ fontSize: 11, fontWeight: 700, color: C.primary }}>{ticket.code}</span>
              {ticket.unread && <span title="Updated" style={{ width: 8, height: 8, borderRadius: 99, background: C.red }} />}
              <span style={{ marginLeft: "auto" }}><StatusChip status={ticket.status} /></span>
            </div>
            <span style={{ fontSize: 12, color: C.textDark, fontWeight: 600 }}>{ticket.title}</span>
            <span style={{ fontSize: 10, color: C.textMid }}>
              {moduleLabel(ticket.module)} · {formatDate(ticket.created_at)}
              {ticket.status === "pending_approval" && ` · ${ticket.progress.approved}/${ticket.progress.required}`}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
